module.exports = __webpack_public_path__ + "static/media/conectogo_fundo.787455c2.jpg";